// offers banner js start

document.addEventListener('DOMContentLoaded', function() {
  new Swiper('.offers-swiper', {
    slidesPerView: 4,
    spaceBetween: 20,
    breakpoints: {
      0: {
        slidesPerView: 1.2,
      },
      600: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
      }
    }
  });
});

// offers banner js end


// trusted brands js start

document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.trusted-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    loop: true
  });
});

// trusted brands js end


// customer review js start

  document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.swiper.review-swiper-container', {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.custom-swiper-button-next.swiper-button-next',
        prevEl: '.custom-swiper-button-prev.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3
        }
      }
    });
  });

// customer review js end